// extracted by mini-css-extract-plugin
export default {"scroll":"viewGroupModal_scroll__TMv02","groupInfo":"viewGroupModal_groupInfo__7YMab"};